<template>
  <div class="tag-input">
    <div class="form-group input-group-lg">
      <div class="tags-container">
                <span class="tag" v-for="(tag, index) in tags" :key="index">
                    {{ tag }}
                     <span class="bi bi-trash text-danger" @click="removeTag(index)" role="button"></span>
                </span>
        <input type="text" class="form-control" id="tags-input" placeholder="Enter tags" v-model="inputValue"
               @keydown.enter.prevent="addTag" @keydown.tab.prevent="addTag">
      </div>
    </div>
    <div class="autocomplete" :hidden="hideAutocomplete">
      <ul>
        <li v-for="(item, index) in filteredItems" :key="index" @click="selectItem(item)">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, onBeforeUnmount, watch, reactive, toRefs} from 'vue';
import {useTagsStore} from '../../stores/tagsStore';

export default {
  name: 'TagInput',
  props: {
    initialTags: {
      type: Array,
      required: true
    }
  },
  setup(props, {emit}) {
    const inputValue = ref('');
    const tags = ref([]);
    const filteredItems = ref([]);
    const hideAutocomplete = ref(true);
    const tagsStore = useTagsStore();

    const addTag = () => {
      if (inputValue.value && !tags.value.includes(inputValue.value)) {
        tags.value.push(inputValue.value);
        inputValue.value = '';
      }

      hideAutocomplete.value = true;
    };

    const removeTag = (index) => {
      tags.value.splice(index, 1);
    };

    const filterItems = () => {
      filteredItems.value = tagsStore.tags.filter(item => {
        return item.toLowerCase().includes(inputValue.value.toLowerCase());
      });

      hideAutocomplete.value = filteredItems.value.length === 0 || inputValue.value === '';
    };

    const selectItem = (item) => {
      inputValue.value = '';
      filteredItems.value = [];
      if (!tags.value.includes(item)) {
        tags.value.push(item);
      }

      hideAutocomplete.value = true;
    };

    const handleClickOutside = (event) => {
      const root = document.getElementById('tag-input');

      if (root && !root.contains(event.target)) {
        filteredItems.value = [];
      }
    };

    onMounted(() => {
      tags.value = props.initialTags;
      window.addEventListener('click', handleClickOutside);

      if (!tagsStore.hydrated) {
        tagsStore.fetchData();
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('click', handleClickOutside);
    });

    watch(inputValue, () => {
      filterItems();
    });

    watch(tags, () => {
      emit('update-tags', tags.value);
    }, {deep: true});

    return {
      inputValue,
      tags,
      filteredItems,
      hideAutocomplete,
      addTag,
      removeTag,
      selectItem
    };
  },
  emits: ['update-tags'],
};
</script>


